(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  /* ----------------- Video behavior ----------------- */
  const items = document.querySelectorAll(".ugc-item");
  let currentVideo = null;

  // Autoplay 3rd video muted (index 2), pause when out of view, resume when visible
  const middleIndex = 2;
  const middleItem = items[middleIndex];
  const middleVideo = middleItem ? middleItem.querySelector(".ugc-video") : null;
  if (middleVideo) {
    middleVideo.muted = true;
    middleVideo.play().catch(()=>{ /* autoplay might be blocked; ok to ignore */ });
    currentVideo = middleVideo;
    const btn = middleItem.querySelector(".ugc-play-btn");
    if (btn) btn.style.display = "none";
  }

  // Play/pause with overlay buttons; ensure only one plays at a time
  items.forEach(item => {
    const video = item.querySelector(".ugc-video");
    const btn = item.querySelector(".ugc-play-btn");
    if (!video || !btn) return;

    btn.addEventListener("click", () => {
      if (currentVideo && currentVideo !== video) {
        currentVideo.pause();
        const prevBtn = currentVideo.parentElement.querySelector(".ugc-play-btn");
        if (prevBtn) prevBtn.style.display = "block";
      }
      video.muted = false; // user intent play -> allow sound
      video.play();
      currentVideo = video;
      btn.style.display = "none";
    });

    video.addEventListener("pause", () => {
      if (video !== middleVideo) btn.style.display = "block";
    });
  });

  // Pause/resume middle video with IntersectionObserver
  if (middleVideo && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && !middleVideo.paused) {
          middleVideo.pause();
        } else if (entry.isIntersecting && middleVideo.paused) {
          middleVideo.play().catch(()=>{});
        }
      });
    }, { threshold: 0.5 });
    observer.observe(middleVideo);
  }

  /* ----------------- Cart add + header refresh ----------------- */
  const selectorsToUpdate = [
    '[data-cart-count]',                       // common data attr
    '#cart-count-bubble',                      // sometimes used as id
    '.cart-count-bubble',                      // Dawn/Broadcast-style bubble
    '.header__cart-count',                     // alt header count class
    '.cart-link__bubble',                      // some Broadcast presets
    '.icon-bubble',                            // generic bubble class
    '.js-cart-count'                           // older themes
  ];

  function updateCartBadges(count) {
    const label = `${count} ${count === 1 ? 'item' : 'items'}`;
    document.querySelectorAll(selectorsToUpdate.join(',')).forEach(el => {
      // If bubble contains two spans like Dawn/Broadcast
      const ariaSpan = el.querySelector('[aria-hidden="true"]') || el.querySelector('[aria-hidden=true]');
      const srSpan = el.querySelector('.visually-hidden, .sr-only');
      if (ariaSpan) ariaSpan.textContent = count;
      if (srSpan) srSpan.textContent = label;

      // Fallback: put count directly
      if (!ariaSpan && !srSpan) el.textContent = count;

      // Show/Hide when zero
      el.style.display = count > 0 ? '' : 'none';
      el.classList.toggle('is-empty', count === 0);
    });
  }

  async function fetchCartJSON() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  // Try to refresh common sections via Section Rendering API
  async function refreshHeaderSections() {
    // These ids are safe to request; API ignores non-existing ids
    const sectionIds = ['cart-icon-bubble','header','cart-drawer'];
    const url = `/?sections=${encodeURIComponent(sectionIds.join(','))}`;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return;

      const htmlMap = await res.json();

      // Helper: replace element with same id from new HTML
      const replaceFromHTML = (targetId, html) => {
        if (!html) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newByExact = doc.getElementById(targetId);
        const newByShopify = doc.querySelector(`#shopify-section-${targetId}`);
        const targetByExact = document.getElementById(targetId);
        const targetByShopify = document.getElementById(`shopify-section-${targetId}`);

        const newEl = newByExact || newByShopify;
        const oldEl = targetByExact || targetByShopify;

        if (newEl && oldEl) {
          oldEl.replaceWith(newEl);
        } else if (targetByExact && html) {
          // As a fallback, inject contents
          targetByExact.innerHTML = html;
        }
      };

      Object.keys(htmlMap).forEach(key => {
        replaceFromHTML(key, htmlMap[key]);
      });
    } catch (e) {
      // Silently ignore; manual badge update still covers the UX
      console.warn('Section refresh skipped', e);
    }
  }

  // Fire common theme events (covers some Broadcast internals)
  function broadcastCartEvents(cartObj) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartObj } }));
      document.dispatchEvent(new CustomEvent('cart:change',  { detail: { cart: cartObj } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cartObj } }));
      window.dispatchEvent(new CustomEvent('cart:updated',   { detail: { cart: cartObj } }));
      window.dispatchEvent(new CustomEvent('cart:change',    { detail: { cart: cartObj } }));
      window.dispatchEvent(new CustomEvent('cart:refresh',   { detail: { cart: cartObj } }));
      // Some Broadcast builds expose a cart helper - call if present
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    } catch (e) {
      /* no-op */
    }
  }

  async function hardRefreshCartUI() {
    const cart = await fetchCartJSON();
    updateCartBadges(cart.item_count);
    await refreshHeaderSections();
    broadcastCartEvents(cart);
  }

  // Bind add-to-cart buttons
  document.querySelectorAll(".add-to-cart-btn").forEach(btn => {
    btn.addEventListener("click", async () => {
      const id = btn.dataset.productId;
      if (!id) return;

      const originalLabel = btn.textContent;
      btn.disabled = true;

      try {
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ id, quantity: 1 })
        });

        if (!addRes.ok) throw new Error('Add to cart failed');

        // Immediately reflect count (optimistic + verified)
        await hardRefreshCartUI();

        // Nice little feedback on the button
        btn.textContent = "✔";
        setTimeout(() => { btn.textContent = originalLabel; }, 1200);
      } catch (err) {
        console.error("Add to cart failed", err);
        btn.textContent = "!";
        setTimeout(() => { btn.textContent = originalLabel; }, 1500);
      } finally {
        btn.disabled = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
